import {useFocus} from 'focus-manager/web';
import * as React from 'react';

import ReservedValue from '../Constants/ReservedValue';
import Backspace from '../Icons/Backspace';
import IKey from '../Interfaces/IKey';

interface IKeyProps extends IKey {
    onSelect: (keyValue: string) => void;
}

const getVisibleValue = (value: string) =>
    ({
        [ReservedValue.BACKSPACE]: '',
        [ReservedValue.DIACRITICS]: 'ÃÇÉ',
        [ReservedValue.ALPHANUMERIC]: 'ABC',
        [ReservedValue.SPACE]: '',
    }[value] ?? value);

const Key: React.FC<IKeyProps> = ({basis, onSelect, value, anchors, focusableIndex}) => {
    const Icon = value === ReservedValue.BACKSPACE ? Backspace : null;
    const handleSelect = React.useCallback(() => onSelect(value), [value]);

    const {setFocusableElementRef} = useFocus({
        focusableBasis: basis,
        focusableAnchors: anchors,
        focusableIndex,
        onSelect: handleSelect,
    });

    const className = [
        'key',
        value === ReservedValue.SPACE && 'key--space-bar',
        value === ReservedValue.ALPHANUMERIC && 'key--alphanumeric',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <button ref={setFocusableElementRef} className={className} data-value={getVisibleValue(value)}>
            {Icon && <Icon />}
        </button>
    );
};

export default React.memo(Key);
